import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import InsuranceForm from "./InsuranceForm";
import SignIn from "./Signin";
import Dashboard from "./Dashboard";
import CostSavingsData from "./CostSavingsData";
import Layout from './Layouts';
import Footer from './Footer';
import { Box } from '@mui/material';
import IICostSavingsForm from "./IICostSavingsForm";
import LandingPage from './LandingPage';
import OtpVerify from './OtpVerify';
import AddUser from "./AddUser";
import Users from "./Users";
import { useEffect, useState } from "react";
  

function App() {
  
  //  const [accessToken, setAccessToken] = useState(
  //   sessionStorage.getItem("accessToken")
  // );

  // useEffect(() => {
  //   setAccessToken(sessionStorage.getItem("accessToken"));
  // }, []);

  return (
    <div className="App">
      <div className="container mt-4">
        <Router>
          <Routes>
            {/* Direct route for Login WITHOUT Layout */}
            <Route path="/login" element={<SignIn />} />
            {/* <Route path="/" element={<InsuranceForm />} /> */}
              <Route path="/" element={<LandingPage />} />
                 <Route path="/ii-cost-savings" element={<IICostSavingsForm />} />
                   <Route path="/signin-otp" element={<OtpVerify />} />
                 

            {/* All other routes under Layout */}
           {/* {accessToken ? ( */}
              <Route path="/" element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/submissions" element={<CostSavingsData />} />
                  <Route path="settings/add-user" element={<AddUser />} />
                   <Route path="settings/users" element={<Users />} />
              </Route>
            {/* ) : ( */}
              /* 🚫 No token → force login */
              {/* <Route path="*" element={<Navigate to="/login" replace />} />
            )} */}

            {/* Redirect any unknown routes to the Login Page */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // minHeight: '100vh', // Make sure the page takes full height
              overflow: 'hidden',  
            }}
          >
            <Box sx={{ flexGrow: 1 }} >
              {/* Your page content here */}
            </Box>
            <Footer />
          </Box>
        </Router>


        {/* <Signin /> */}
      </div>
    </div>
  );
}

export default App;
